@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/forms/text-field";
@use "../../../globals/bcp-2022/objects/forms/forms-settings" as forms;

$self: ".a-text-field-group";

:host {
  // ------------------- FIX CUSTOM TAGS ------------------------------------------------------------------------------
  display: block;
}

// ------------------- BCP ------------------------------------------------------------------------------------------
.a-text-field-group {
  &__legend {
    @include text-field.text-field-label;
  }

  &__row {
    @include text-field.like-text-field-input;
    display: flex;
    border-width: 0 0 1px;

    ::slotted(f-text-field) {
      flex-grow: 1;
    }
  }

  &:not(#{$self}--disabled) {
    ::slotted(#{$self}__button:not(#{$self}--not-allowed):hover) {
      @include bcp.set-css-var(
        button-integrated-hover,
        color,
        settings.$text-color
      );
      background-color: text-field.$input-hover-bg;
    }
  }

  &--disabled {
    #{$self}__row {
      border-bottom-color: forms.$forms-disabled-border;
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
